import React from "react";
import { Container, Table } from "semantic-ui-react";
import shortid from "shortid";
import TableRow from "./tablaColegiosEscuelas/TableRow";
import { sortBy } from "lodash";

class TablaColegiosEscuelas extends React.Component {
  state = {
    column: "nombre",
    data: this.props.datos,
    direction: "ascending"
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ data: sortBy(nextProps.datos, "nombre") });
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: sortBy(data, [clickedColumn]),
        direction: "ascending"
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending"
    });
  };

  render() {
    const { column, data, direction } = this.state;

    return (
      <Container fluid>
        <Table sortable compact celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={column === "nombre" ? direction : null}
                onClick={this.handleSort("nombre")}
                content="Colegio"
              />
              <Table.HeaderCell
                sorted={column === "poblacion" ? direction : null}
                onClick={this.handleSort("poblacion")}
                content="Población"
              />
              <Table.HeaderCell
                sorted={column === "provincia" ? direction : null}
                onClick={this.handleSort("provincia")}
                content="Provincia"
              />
              <Table.HeaderCell content="Eliminar Escuela" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.map(item => (
              <TableRow
                key={shortid.generate()}
                item={item}
                handleClick={this.props.handleRowClick}
                handleBorrarLinea={this.props.handleBorrarLinea}
              />
            ))}
          </Table.Body>
        </Table>
      </Container>
    );
  }
}

export default TablaColegiosEscuelas;



// WEBPACK FOOTER //
// ./src/pages/escuelas/buscadores/colegios/TablaColegiosEscuelas.jsx